import shopOfTheYearWinners from './shop-of-the-year-winners';
import shopOfTheYearLandingPage from './shop-of-the-year-landing-page';

export default (props, context) => {
  if (!props.data) {
    return {};
  }

  if (props.data.shopOfTheYear) {
    return shopOfTheYearLandingPage(props, context);
  }

  return shopOfTheYearWinners(props, context);
};
